import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TextField from '@mui/material/TextField';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import swal from 'sweetalert';
import Config from './components/ClientConfig';
import Client from './components/Client';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  paddingLeft: 8,
  paddingRight: 8,
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#273442",
    color: theme.palette.common.white,
    paddingTop: 4,
    paddingBottom: 4,
    lineHeight: '20px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const isColorKey = (key) => /COLOU?R/i.test(key);
const isHexColor = (value) => /^#[0-9a-f]{6}$/i.test(value);

class DataRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {   
      client: new Client ( "none" ),   
      edit: false,
      row: {},
      keyValid: false,
      valueValid: false,
      somethingHasChanged: false,
    };

    
    this.handleEditClick = this.handleEditClick.bind(this);
    //this.getImage = this.getImage.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

  }

  componentDidMount() {
    let row = {};
    if ( this.props.row ) {
      row = this.props.row;
      this.setState ( { row: row } );
      if ( row.key.length > 0 ) this.setState ( {keyValid: true } );
      if ( row.value.length > 0 ) this.setState ( {valueValid: true } );
    }
    if ( this.props.edit ) this.setState ( { edit: true } );
  }

  handleEditClick ( ) {
    this.setState({ edit: !this.state.edit });
  }

  changeValue ( e ) {
    let id = e.target.name || e.target.id;
    let value = null;
    if  ( e.target.value !== null ) value = e.target.value;
    //if ( id !== null && value !== null && value !== undefined ) {
    if ( id ) {
      let row = {};
      if ( this.state.row ) row = this.state.row;
      switch ( id ) {
        case "key":
          if ( value.length > 0 ) {
            row.key = value;
            this.setState ( { keyValid: true });
          } else {
            row.key = "";
            this.setState ( { keyValid: false });
          }
          this.setState ( { somethingHasChanged: true } );
          break;
        case "color":
        case "value":
          if ( value.length > 0 ) {
            row.value = id === "color" ? value.toUpperCase() : value;
            this.setState ( { valueValid: true });
          } else {
            row.value = "";
            this.setState ( { valueValid: false });
          }
          this.setState ( { somethingHasChanged: true } );
          break;
        case "description":
          row.description = value || "";
          this.setState({ somethingHasChanged: true });
          break;
        default:
          console.warn(`Unhandled id: ${id}`);
          break;
      }
      this.setState ( { row: row });
    }
  }

  pushData ( e ) {
    if ( this.state.somethingHasChanged && this.state.keyValid && this.state.valueValid ) {
      const rowToSave = isColorKey(this.state.row.key) && isHexColor(this.state.row.value)
        ? { ...this.state.row, value: this.state.row.value.toUpperCase() }
        : this.state.row;
      let rdata = this.state.client.pushData ( Config.API_URL_CONFIG_MOBILEAPP_ADD, rowToSave );
      if ( rdata ) {
        if ( rdata.status === "OK" ) {
          let uRow = rowToSave;
          uRow.iref = rdata.data?.iref;
          this.setState ( { row: uRow } );
          this.handleEditClick ( );
          swal ( "Success", "Successfully added/modified configuration value ! (" + rdata.iref + ")", "success", {
            buttons: false,
            timer: 2000,
          })
          .then((value) => {
            //this.props.personUpdated ( );
            this.setState ( {edit: false} );
            this.setState ( { somethingHasChanged: false } );
            this.props.rowAdded ();
          });        
        } else {
          if ( rdata.message ) this.setState ( { errorMessage: rdata.message } );
          swal ( "Error", "Add/Update configuration value failed !\n\n" + rdata.message, "error" );
        }
      }
    } else {
      swal ( "Error", "Add/Update configuration value failed ! Some fields are not validated !", "error" );
    }
  }

  render() {
    let row = {};
    let iref = "0";
    let key = "";
    let value = "";
    let description = "";
    if ( this.state.row ) {
      row = this.state.row;
      if ( row.iref ) iref = row.iref;
      if ( row.key ) key = row.key;
      if ( row.value ) value = row.value;
      if ( row.description ) description = row.description;    
    }
    if ( this.props.dataRow !== null && this.props.dataRow !== undefined ) {
      row = this.props.dataRow;
    }

    let showSave = false;
    if ( this.state.edit === true && this.state.somethingHasChanged === true && this.state.keyValid === true && this.state.valueValid === true )
      showSave = true;
    const textCellSx = this.state.edit ? undefined : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
    const hasColorKey = isColorKey(key);
    const pickerValue = isHexColor(value) ? value : '#000000';


    return (
      <StyledTableRow key={row.iref} sx={{ display: this.props.hidden ? 'none' : undefined }}>
        <StyledTableCell align="left" title={iref} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {iref}
        </StyledTableCell>
        <StyledTableCell scope="row" title={this.state.edit ? undefined : key} sx={textCellSx}>
          {this.state.edit ? 
          <TextField
            id="key"
            label="Key"
            variant="outlined"
            value={key || ''}
            onChange={this.changeValue}
            onFocus={event => { event.target.select(); }}
            inputProps={{maxLength:"64"}}
            error={this.state.keyValid === false}
            required={true}
            sx={{ width: '100%', minWidth: 0 }}
            autoFocus={!!this.props.autoFocusKey}
          />
          : key }
        </StyledTableCell>
        
        <StyledTableCell align="left" title={this.state.edit ? undefined : value} sx={textCellSx}>
          {this.state.edit ? 
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
              <TextField
                id="value"
                label="Value"
                variant="outlined"
                value={value || ''}
                onChange={this.changeValue}
                onFocus={event => { event.target.select(); }}
                inputProps={{maxLength:"255"}}
                error={this.state.valueValid === false}
                required={true}
                sx={{ flex: 1, minWidth: 0, maxWidth: hasColorKey ? 120 : undefined }}
              />
              {hasColorKey && (
                <Box sx={{ width: 52, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
                  <Typography component="span" sx={{ fontSize: '0.65rem', lineHeight: '12px', color: 'text.secondary' }}>Color</Typography>
                  <input
                    name="color"
                    type="color"
                    aria-label={`Choose color for ${key}`}
                    title="Choose color"
                    value={pickerValue}
                    onChange={this.changeValue}
                    style={{ width: 52, height: 34, padding: 0, border: 0, background: 'transparent', cursor: 'pointer' }}
                  />
                </Box>
              )}
            </Box>
            : <>
                {hasColorKey && isHexColor(value) && (
                  <Box component="span" aria-hidden="true" sx={{ display: 'inline-block', width: 18, height: 18, mr: 0.75, verticalAlign: 'middle', backgroundColor: value, border: '1px solid #777', borderRadius: 0.5 }} />
                )}
                {value}
              </>}
          </StyledTableCell>

        <StyledTableCell align="left" title={this.state.edit ? undefined : description} sx={textCellSx}>
          {this.state.edit ?
            <TextField
              id="description"
              label="Description"
              variant="outlined"
              value={description || ""}
              onChange={this.changeValue}
              multiline
              minRows={1}
              maxRows={3}
              sx={{ width: '100%', minWidth: 0 }}
            />
            : description
          }
        </StyledTableCell>
        
        <StyledTableCell align="right">
          <IconButton size="small" aria-label="settings" onClick={this.handleEditClick} sx={{ p: 0.25 }}>
            <EditIcon
              sx={{ color: this.state.edit ? "#8f241d" : "#e3e3e5" }}              
            />
        </IconButton>
        {showSave ?
          <IconButton size="small" aria-label="settings" onClick={this.pushData} sx={{ p: 0.25 }}>
            <SaveIcon
              sx={{ color: "#4287f5" }}            
            />
      </IconButton>
        : ""}
        </StyledTableCell>
      </StyledTableRow>
    );
  }
}


class ConfigMobileApp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      rows: null,
      rowsVersion: 0,
      edit: false,
      addRow: false,
      queryData: {},
      searchText: '',
      //addNewProduct: false,
    };

    this.rowAdded = this.rowAdded.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.getData = this.getData.bind(this);
    this.tableRef = React.createRef();
  }

  getData ( ) {
    let queryData = {};
    queryData[ "orderBy" ] = "key";
    this.setState ( { queryData: queryData } );
    let data = this.state.client.getData ( Config.API_URL_CONFIG_MOBILEAPP, queryData );
    this.setState ( (state) => ({ rows: data.MobileAppConfigs, rowsVersion: state.rowsVersion + 1 }) );
  }

  componentDidMount() {    
    this.getData ( );    
  }

  componentWillUnmount() {    
  }

  rowAdded ( ) {
    this.getData ( );
    this.setState ( { addRow: false } );
  }

  toggleAdd() {
    const addButton = this.state.addRow;
    this.setState({ addRow: !addButton }, () => {
      if (!addButton && this.tableRef.current) {
        // smooth scroll when opening the add row
        const el = this.tableRef.current;
        if (el.scrollTo) el.scrollTo({ top: 0, behavior: 'smooth' });
        else el.scrollTop = 0;
      }
    });
  }

  
  render() {
    const rows = Array.isArray(this.state.rows) ? this.state.rows : [];
    const searchText = this.state.searchText.trim().toLowerCase();
    const hasFilters = !!this.state.searchText;
    let matchingRows = 0;
    const allData = rows.map((row) => {
      const matches = !searchText || `${row.key || ''} ${row.description || ''}`.toLowerCase().includes(searchText);
      if (matches) matchingRows += 1;
      return <DataRow
        key={`${this.state.rowsVersion}-${row.iref}`}
        row={row}
        rowAdded={this.rowAdded}
        hidden={!matches}
      />;
    });

    return (
      <>
      <Box sx={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap',
        columnGap: 2, rowGap: 0.5, px: 1.5, py: 0.5, mb: 0.75,
        borderRadius: 2, backgroundColor: '#214a80',
        '& .MuiInputBase-input': { fontSize: '0.875rem', py: 0.25 },
      }}>
        <TextField
          size="small"
          label="Key or description"
          variant="standard"
          value={this.state.searchText}
          onChange={(event) => this.setState({ searchText: event.target.value })}
          InputLabelProps={{ sx: { color: '#e3e3e5' } }}
          InputProps={{ sx: { color: '#e3e3e5' } }}
          sx={{ minWidth: 220 }}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 'auto', pl: 2 }}>
          <Typography variant="body2" title="Matching / total configurations" aria-label={`${matchingRows} of ${rows.length} configurations`} sx={{ color: '#e3e3e5' }}>
            {matchingRows}/{rows.length}
          </Typography>
          <IconButton
            size="small"
            aria-label="Clear filters"
            title="Clear filters"
            disabled={!hasFilters}
            onClick={() => this.setState({ searchText: '' })}
            sx={{ p: 0.25, opacity: hasFilters ? 1 : 0.45 }}
          >
            <Avatar alt="Clear filters" sx={{ width: 18, height: 18, color: '#99302e' }}>
              <HighlightOffIcon fontSize="small" />
            </Avatar>
          </IconButton>
        </Box>
      </Box>
      <TableContainer component={Paper} sx={{ maxHeight: '90vh', width: '100%', overflowX: 'auto' }} ref={this.tableRef}>
      <Table stickyHeader sx={{ width: '100%', minWidth: 760, tableLayout: 'fixed' }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ width: 160, py: 0.25 }}>
              <IconButton size="small" aria-label="Add configuration" title="Add configuration" onClick={this.toggleAdd} sx={{ p: 0.25 }}>
                <Avatar alt="Add configuration" sx={{ width: 22, height: 22, color: '#273442' }}>
                  {this.state.addRow ? <FaMinusCircle /> : <FaPlusCircle />}
                </Avatar>
              </IconButton>
            </StyledTableCell>
            <StyledTableCell>
              Name
            </StyledTableCell>
            <StyledTableCell align="left">Value</StyledTableCell>
            <StyledTableCell align="left">Description</StyledTableCell>
            <StyledTableCell align="right" sx={{ width: 76 }}>Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.addRow ?
          <DataRow key={0} edit={true} rowAdded={this.rowAdded} autoFocusKey/>
          : ""
          }
          {allData}
          {this.state.rows !== null && hasFilters && matchingRows === 0 && (
            <TableRow>
              <StyledTableCell colSpan={5} align="center" sx={{ py: 3 }}>
                No configurations match your filters.
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
      </>

    );

  }
}

export default ConfigMobileApp;
